// Author thq
// Date 2021-11-02 15:06:10

class EmSppSparePartsCatSpc {
constructor({
        id = null,
        sid = '',
        parentNcid = '',
        code = '',
        name = '',
        parentId = '',
        level = '',
        nodeCode = '',
        seq = '',
        spcRemark = ''}
= {}) {
    this.id = id;
    this.sid = sid;
    this.parentNcid = parentNcid;
    this.code = code;
    this.name = name;
    this.parentId = parentId;
    this.level = level;
    this.nodeCode = nodeCode;
    this.seq = seq;
    this.spcRemark = spcRemark;
}
}

function newEntity() {
return new EmSppSparePartsCatSpc();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.spareparts.emSppSparePartsCatSpc.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sid',
        label: 'label.em.spareparts.emSppSparePartsCatSpc.grid.sid',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'parentNcid',
        label: 'label.em.spareparts.emSppSparePartsCatSpc.grid.parentNcid',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.em.spareparts.emSppSparePartsCatSpc.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.em.spareparts.emSppSparePartsCatSpc.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'parentName',
        label: 'label.em.spareparts.emSppSparePartsCatSpc.grid.parentName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'level',
        label: 'label.em.spareparts.emSppSparePartsCatSpc.grid.level',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'nodeCode',
        label: 'label.em.spareparts.emSppSparePartsCatSpc.grid.nodeCode',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'seq',
        label: 'label.em.spareparts.emSppSparePartsCatSpc.grid.seq',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'spcRemark',
        label: 'label.em.spareparts.emSppSparePartsCatSpc.grid.spcRemark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    sidFilter : '',
    parentNcidFilter : '',
    codeFilter : '',
    nameFilter : '',
    parentIdFilter : '',
    parentNameFilter : '',
    levelFilter : '',
    nodeCodeFilter : '',
    seqFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'codeFilter',
        label: 'label.em.spareparts.emSppSparePartsCatSpc.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.em.spareparts.emSppSparePartsCatSpc.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'parentNameFilter',
        label: 'label.em.spareparts.emSppSparePartsCatSpc.filter.parentName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'sid',
        label: 'label.em.spareparts.emSppSparePartsCatSpc.entity.sid',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'parentNcid',
        label: 'label.em.spareparts.emSppSparePartsCatSpc.entity.parentNcid',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'code',
        label: 'label.em.spareparts.emSppSparePartsCatSpc.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'name',
        label: 'label.em.spareparts.emSppSparePartsCatSpc.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'parentId',
        label: 'label.em.spareparts.emSppSparePartsCatSpc.entity.parentId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'level',
        label: 'label.em.spareparts.emSppSparePartsCatSpc.entity.level',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'nodeCode',
        label: 'label.em.spareparts.emSppSparePartsCatSpc.entity.nodeCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'seq',
        label: 'label.em.spareparts.emSppSparePartsCatSpc.entity.seq',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'spcRemark',
        label: 'label.em.spareparts.emSppSparePartsCatSpc.entity.spcRemark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmSppSparePartsCatSpc, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
